'use strict';

var ApproveModalDirecitve = function ApproveModalDirecitve() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/approve-modal.html'),
    controller: 'ApproveModalController',
    link: function link($scope, element) {
      $scope.hideApproveModal = function () {
        element.modal('hide');
      };
    }
  };
};
ApproveModalDirecitve.inject = [];
module.exports = ApproveModalDirecitve;